var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link"},[_c('router-link',{class:{nested: _vm.route.type == 'nested'},attrs:{"to":_vm.route.path},nativeOn:{"click":function($event){return _vm.clearSearch()}}},[_vm._v(_vm._s(_vm.route.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }